(function () {
  function addSubToCart(button) {
    var subSwitch = document.querySelector('.sub-switch');
    var productId = subSwitch.getAttribute('data-productid');
    var sellingPlanId = subSwitch.getAttribute('data-sellingplanid');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: productId, quantity: 1, selling_plan: sellingPlanId }]
      })
    }).then(function () {
      button.closest('form').submit();
    });
  }

  document.addEventListener('click', function (e) {
    var label = e.target.closest('variant-radios label');
    if (label) {
      label.closest('variant-radios').onVariantChange();
      return;
    }

    var subSwitch = e.target.closest('.sub-switch');
    if (subSwitch) {
      subSwitch.parentElement.classList.toggle('active');
      return;
    }

    var submitBtn = e.target.closest('.product-form__submit');
    if (submitBtn) {
      var container = document.querySelector('.sub-switch-container');
      if (container && container.classList.contains('active')) {
        e.preventDefault();
        addSubToCart(submitBtn);
      }
    }
  });
})();
